import type { ModuleItemType, SubmoduleItem } from 'app/types/modules';
import React from 'react';
import Button from '../../../../atoms/Button/Button';
import TooltipCustom from '../../../../atoms/Tooltip/Tooltip';
import useItemActions from './useItemActions';

type ItemActionsProps = {
  item: ModuleItemType | SubmoduleItem;
  onDelete?: (item: ModuleItemType | SubmoduleItem) => void;
  onEdit?: (item: ModuleItemType | SubmoduleItem) => void;
  onToggleVisibility?: (item: ModuleItemType | SubmoduleItem) => void;
};

function ItemActions({ item, onDelete, onEdit, onToggleVisibility }: ItemActionsProps): JSX.Element {
  const {
    canEditItem,
    deleteLabel,
    deleteTooltip,
    editLabel,
    editTooltip,
    handleDelete,
    handleEdit,
    handleToggleVisibility,
    visibilityIcon,
    visibilityLabel,
    visibilityTooltip,
  } = useItemActions({ item, onDelete, onEdit, onToggleVisibility });

  return (
    <div className="item-actions">
      <TooltipCustom title={visibilityTooltip} placement="top" hasArrow>
        <Button
          variant="plain"
          isIconOnly
          leftIcon={visibilityIcon}
          iconSize="lg"
          ariaLabel={visibilityLabel}
          ariaHasPopup="dialog"
          onClick={handleToggleVisibility}
        />
      </TooltipCustom>
      {canEditItem && (
        <>
          <TooltipCustom title={editTooltip} placement="top" hasArrow>
            <Button variant="plain" isIconOnly leftIcon="editpost" iconSize="lg" ariaLabel={editLabel} ariaHasPopup="dialog" onClick={handleEdit} />
          </TooltipCustom>
          <TooltipCustom title={deleteTooltip} placement="top" hasArrow>
            <Button
              className="item-actions__delete"
              variant="plain"
              isIconOnly
              leftIcon="trash"
              iconSize="lg"
              ariaLabel={deleteLabel}
              ariaHasPopup="dialog"
              onClick={handleDelete}
            />
          </TooltipCustom>
        </>
      )}
    </div>
  );
}

export default ItemActions;
